import { Typography, Box, Divider, Button, Tab, Tabs, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Control, FieldValues, UseFormSetValue, useWatch } from "react-hook-form";
import { CustomFormField } from "@utilifiles/component/CustomFormElement";
import { getAllConsentFormList, getConsentForm } from "../../../../EMR/components/ConsenForms/services";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import usePopup from "@hooks/usePopup";
import { useFormBuilder } from "../formMasterContext";

const KEY_NAME_OPTIONS = [
  // pmaster keys
  "patientId", "patientName", "firstName", "middleName", "lastName", "gender", "dob", "age", "emiratesId", "passportNum", "gccId", "foDate", "raceId", "raceName", "religionId", "religionName", "maritalId", "maritalName", "languageId", "languageName", "priority", "grouping", "isVip", "isEstablished", "globalConsent", "a28MsgStatus", "paymentMode",
  // amaster keys
  "mobileNo", "email", "address1", "address2", "place", "stateId", "stateName", "countryId", "countryName", "conCode", "countryCode", "clinicCountryId", "clinicCountryName", "addressType", "uploadfile", "patientMasterID", "addressMasterID", "howKnow", "photoName",
  // encounter keys
  "encounterId", "pmasterId", "createdDate", "purposeId", "purposeName", "referBy", "referredBy", "departmentId", "departmentName", "doctorId", "doctorName", "clinicName", "facilityLicenseNo", "liscenceNo", "visitType", "packageId", "packageName", "packageActualRate", "packageFinalRate", "startTime", "endTime", "knewAbout",
  // insurance keys
  "insurance", "insurance_name", "insuranceType", "insurancetype_name", "insuranceGroup", "inGroup_name", "insurancePlan", "inPlan_name", "policyNo", "cardNo", "policyValidity", "policyValidityFrom", "cardPhoto", "cardPhoto2", "asopNo",
  // company & post office keys
  "companyId", "cmpPatientID", "com_patientMasterID", "postofficeId", "postofficeName", "econtactOne", "econtactTwo"
];

const FormConfiguration = ({
  control,
  setValue,
  refetchlistofForms,
  resetKey 
}: {
  control: Control<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  refetchlistofForms: boolean,
  resetKey: number;
}) => {
  const [consentFormList, setConsentFormList] = useState<any[]>([]);
  const [tabValue, setTabValue] = useState(0);
  const {  setExistingFormfromContext, setFormData } = useFormBuilder();
  const [confirmDialog, setConfirmDialog] = useState<{ open: boolean, onConfirm: () => void, onCancel?: () => void }>({ open: false, onConfirm: () => {} });

  const resetFormState = () => {
    setValue("templateImage", "");
    setValue("fields", []);
    setValue("existingForm", null);
    setValue("formName", "");
    setValue("formLanguage", null);
    setValue("selectedForm", null);
    setValue("direction", null);
    setValue("orientation", null);
    setValue("fieldType", null);
    setValue("keyName", null);
    setValue("activeTool", null);
    setValue("selectedFieldId", null);
    setFormData({ templateMetadata: { templateImage: "", fields: [] }, formName: "" });
  };

  const handleSwitch = (action: () => void, onCancel?: () => void) => {
    const hasChanges = control._formValues.templateImage || (control._formValues.fields && control._formValues.fields.length > 0);
    if (hasChanges) {
      setConfirmDialog({
        open: true,
        onConfirm: () => {
          action();
          setConfirmDialog({ open: false, onConfirm: () => {} });
        },
        onCancel: () => {
          if (onCancel) onCancel();
          setConfirmDialog({ open: false, onConfirm: () => {} });
        }
      });
    } else {
      action();
    }
  };

  const handleTabChange = (_: any, newValue: number) => {
    if (tabValue === newValue) return;
    handleSwitch(() => {
      resetFormState();
      setTabValue(newValue);
    });
  };
  const { showSnackbar } = usePopup();

  const selectedForm = useWatch({
    control,
    name: "existingForm"
  });
  const currentTemplateImage = useWatch({
    control,
    name: "templateImage"
  });
  
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  useEffect(() => {
    if (!currentTemplateImage) {
      setFileInputKey(Date.now());
    }
  }, [currentTemplateImage]);
  useEffect(() => {
    if (selectedForm?.templateId) {
      getConsentFormDetails(selectedForm.templateId);
    }
  }, [selectedForm?.templateId]);
  // const selectedField = fields?.find((f: any) => f.id === selectedFieldId);

  //   const formatTemplateImage = (img: string) => {
  //   if (!img) return "";
  //   if (img.startsWith("data:")) return img;

  //   const isPdf = img.startsWith("JVBER");

  //   return isPdf
  //     ? `data:application/pdf;base64,${img}`
  //     : `data:image/png;base64,${img}`;
  // };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setValue("templateImage", reader.result);
        setFormData((prev: any) => ({
          ...prev,
          templateMetadata: { ...prev?.templateMetadata, templateImage: reader.result }
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const { mutate: getAllConsentFormListx, isLoading: _allConsentFormListLoading } =
    useMutation(getAllConsentFormList, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          console.log("allConsentFormListx====>>>>>>>>>>>>>>>>>>", result.response)
          setConsentFormList(result.response);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000
          });
        }
      },
    });
  useEffect(() => {
    getAllConsentFormListx()
    // setCustomFormData(selectedForm?.templateId)
  }, [refetchlistofForms])

  const { mutate: getConsentFormDetails, isLoading: isFetchingDetails } = useMutation(getConsentForm, {
    onSuccess: (result) => {
      if (result.responseIndicator === "success" && result.response) {
        const data = result.response.templateMetadata || result.response;

        setFormData({
          templateMetadata: {
            templateImage: data.templateImage,
            fields: data.fields || [],
          },
          formName: result.response.formName || data.formName,
        });

        setValue("templateImage", data.templateImage);
        setValue("fields", data.fields || []);
        setValue("formName", result.response.formName || data.formName || "");
        setExistingFormfromContext(true);
      } else {
        showSnackbar({
          message: result.responseMessage || "Failed to load form details",
          open: true,
          variant: "warning",
          duration: 2000
        });
      }
    }
  });

  useEffect(() => {
    setValue("isFetchingForm", isFetchingDetails);
  }, [isFetchingDetails, setValue]);

  const existingForms = [
    { id: 1, name: "Consent Form" },
    { id: 2, name: "Dental Form" },
    { id: 3, name: "Patient Intake Form" },
    { id: 4, name: "Medical History Form" }
  ];

  return (
    <Box className="flex flex-col h-full">

      <div className="mb-4">
        <Typography>Form Configuration</Typography>
      </div>
      <Divider />


      <div className="flex flex-col gap-2 animate-in fade-in duration-300 mt-4">
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, bgcolor: 'white', borderRadius: '8px 8px 0 0' }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              minHeight: '44px',
              '.MuiTab-root': { textTransform: 'none', fontWeight: 600, minHeight: '44px', fontSize: '0.9rem' }
            }}
          >
            <Tab label="New Form" />
            <Tab label="Existing Form" />
          </Tabs>
        </Box>
        {tabValue === 0 && (
          <>
            <CustomFormField
              control={control}
              name="selectedForm"
              element="autocomplete"
              options={existingForms}
              autocompleteProps={{
                isOptionEqualToValue: (opt: any, val: any) => opt.id === val?.id,
                getOptionLabel: (opt: any) => opt.name || "",
              }}
              fieldProps={{ label: "Select Form Template", size: "small" } as any}
              rules={{ required: "Format is required" }}
            />
            <CustomFormField
              control={control}
              name="formName"
              element="input"
              fieldProps={{ label: "Form Name", size: "small" }}
              rules={{ required: "Format is required" }}
            />
         
            <div>
              <Typography variant="caption" className="font-bold uppercase text-blue-600 block mb-1">
                Template Image
              </Typography>
                <div className="px-3 py-2 border-2 border-dashed border-blue-100 rounded-lg bg-blue-50/30 flex flex-col items-center mb-2">
            <input
              key={fileInputKey}
              type="file"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              className="block w-full text-[10px] text-slate-500 file:mr-3 file:py-1 file:px-3 file:rounded-full file:border-0 file:text-[10px] file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700 cursor-pointer"
            />
          </div>
            </div>
          </>
        )}

        {tabValue === 1 && (
          <>
            <CustomFormField
              control={control}
              name="existingForm"
              element="autocomplete"
              options={consentFormList}
              autocompleteProps={{
                isOptionEqualToValue: (opt: any, val: any) => opt.templateId === val?.templateId,
                getOptionLabel: (opt: any) => opt.formName || "",
                onChange: (_: any, value: any) => {
                  const previousForm = selectedForm;
                  setValue("existingForm", previousForm);

                  handleSwitch(
                    () => {
                      resetFormState();
                      setValue("existingForm", value);
                    },
                    () => {
                      setValue("existingForm", previousForm);
                    }
                  );
                }
              }}
              fieldProps={{ label: "Select Existing Form", size: "small" } as any}
              rules={{ required: "Existing form is required" }}
            />
          </>
        )}

        <div className="grid grid-cols-2 gap-3">
        </div>
        <div className="grid grid-cols-2 gap-3">
          <CustomFormField
            control={control}
            name="fieldType"
            element="autocomplete"
            options={["text", "underline", "signature"]}
            fieldProps={{ label: "Field Type", size: "small" }}
            rules={{ required: "Format is required" }}
          />
          <CustomFormField
            key={`keyName-${resetKey}`}
            control={control}
            name="keyName"
            element="autocomplete"
            options={KEY_NAME_OPTIONS}
            autocompleteProps={{
              freeSolo: true,
              
            }}
            fieldProps={{ label: "Field Name", size: "small" }}
            rules={{ required: "Format is required" }}
          />


          <CustomFormField
            control={control}
            name="orientation"
            element="autocomplete"
            options={["Portrait", "Landscape"]}
            fieldProps={{ label: "Orientation", size: "small" } as any}
            rules={{ required: "Format is required" }}
          />
          <CustomFormField
            control={control}
            name="direction"
            element="autocomplete"
            options={[
              { label: "Left to Right (LTR)", value: "ltr" },
              { label: "Right to Left (RTL)", value: "rtl" }
            ]}
            autocompleteProps={{
              isOptionEqualToValue: (opt: any, val: any) => opt.value === val?.value,
              getOptionLabel: (opt: any) => opt.label || "",
            }}
            fieldProps={{ label: "Text Direction", size: "small" } as any}
            rules={{ required: "Format is required" }}
          />
        </div>
        <div className="flex justify-end">
          <Button
            onClick={() => {
              const selectedType = control._formValues.fieldType;
              setValue("activeTool", selectedType); // ✅ store tool
            }}
          >
            Select Tool
          </Button>
        </div>
        <Divider sx={{ mt: 3 }} />

      </div>

      <Dialog open={confirmDialog.open} onClose={() => {
        if (confirmDialog.onCancel) confirmDialog.onCancel();
        else setConfirmDialog({ ...confirmDialog, open: false });
      }}>
        <DialogTitle>Unsaved Changes</DialogTitle>
        <DialogContent>
          <Typography>Do you want to switch without saving? This will reset the current preview.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            if (confirmDialog.onCancel) confirmDialog.onCancel();
            else setConfirmDialog({ ...confirmDialog, open: false });
          }} color="inherit">
            Cancel
          </Button>
          <Button onClick={confirmDialog.onConfirm} color="error" variant="contained">
            Yes, Switch
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FormConfiguration;